<template>
  <div class="tc-container">
    <ul>
      <li :class="actvIndex == 1 ? 'is-active' : ''" @click="handSelect(1)">
        今日
      </li>
      <li :class="actvIndex == 2 ? 'is-active' : ''" @click="handSelect(2)">
        近七天
      </li>
      <li :class="actvIndex == 3 ? 'is-active' : ''" @click="handSelect(3)">
        本月
      </li>
      <li :class="actvIndex == 4 ? 'is-active' : ''" @click="handSelect(4)">
        本年
      </li>
    </ul>
    <div class="tp-chart" ref="myChart"></div>
  </div>
</template>
<script>
  export default {
    props: {},
    data() {
      return {
        actvIndex: 1,
      }
    },
    mounted() {
      this.init()
    },
    methods: {
      init() {
        let chartDom = this.$refs.myChart
        let myChart = this.$echarts.init(chartDom)
        let xData = ['小轿车', '中巴车', '大巴车']
        let yData = [26, 29, 21]
        let option = {
          grid: {
            top: '25%',
            left: '2%',
            bottom: '5%',
            right: '5%',
            containLabel: true,
          },
          tooltip: {
            show: true,
          },
          animation: false,
          xAxis: [
            {
              type: 'category',
              data: xData,
              axisTick: {
                alignWithLabel: true,
              },
              nameTextStyle: {
                color: '#82b0ec',
              },
              axisLine: {
                show: false,
                lineStyle: {
                  color: '#82b0ec',
                },
              },
              axisLabel: {
                textStyle: {
                  color: '#fff',
                },
                margin: 30,
              },
            },
          ],

          yAxis: {
            splitLine: {
              show: false,
            },
            axisTick: {
              show: false,
            },
            axisLine: {
              show: false,
            },
            axisLabel: {
              textStyle: {
                color: 'transparent',
                fontSize: 14,
              },
            },
          },
          series: [
            {
              name: '',
              type: 'pictorialBar',
              symbolSize: [20, 10],
              symbolOffset: [0, -6], // 上部椭圆
              symbolPosition: 'end',
              z: 12,
              // "barWidth": "0",
              label: {
                normal: {
                  show: true,
                  position: 'top',
                  // "formatter": "{c}%"
                  fontSize: 15,
                  fontWeight: 'bold',
                  color: '#FFFFFF',
                },
              },
              color: '#2DB1EF',
              data: yData,
            },
            {
              name: '',
              type: 'pictorialBar',
              symbolSize: [20, 10],
              symbolOffset: [0, 7], // 下部椭圆
              // "barWidth": "20",
              z: 12,
              color: '#2DB1EF',
              data: yData,
            },
            {
              name: '',
              type: 'pictorialBar',
              //   symbolSize: function (d) {
              //     return d > 0 ? [50, 15] : [0, 0]
              //   },
              symbolSize: [35, 12],
              symbolOffset: [0, 14], // 下部内环
              z: 10,
              itemStyle: {
                normal: {
                  color: 'transparent',
                  borderColor: '#00EAFF',
                  borderType: 'solid',
                  borderWidth: 8,
                },
              },
              data: yData,
            },
            {
              name: '',
              type: 'pictorialBar',
              symbolSize: [45, 12],
              symbolOffset: [0, 18], // 下部外环
              z: 10,
              itemStyle: {
                normal: {
                  color: 'transparent',
                  borderColor: '#00EAFF',
                  borderType: 'solid',
                  borderWidth: 8,
                },
              },
              data: yData,
            },
            {
              type: 'bar',
              //silent: true,
              barWidth: '20',
              barGap: '10%', // Make series be overlap
              barCateGoryGap: '10%',
              itemStyle: {
                normal: {
                  color: new this.$echarts.graphic.LinearGradient(
                    0,
                    0,
                    0,
                    0.7,
                    [
                      {
                        offset: 0,
                        color: '#00D6EA',
                      },
                      {
                        offset: 1,
                        color: '#00EAFF',
                      },
                    ]
                  ),
                  opacity: 0.6,
                },
              },
              data: yData,
            },
          ],
        }
        myChart.setOption(option)
        window.addEventListener('resize', () => {
          myChart.resize()
        })
      },
      handSelect(i) {
        this.actvIndex = i
      },
    },
  }
</script>
<style lang="scss" scoped>
  .tc-container {
    ul {
      list-style: none;
      display: flex;
      justify-content: flex-end;
      color: #15a983;
      cursor: pointer;
      li {
        margin-right: 30px;
        white-space: nowrap;
      }
      .is-active {
        border-bottom: 1px solid #ffc600;
        padding-bottom: 7px;
        position: relative;
        color: #fff;
        &::after {
          content: '';
          width: 0;
          height: 0;
          border-bottom: 5px solid #ffc600;
          border-left: 5px solid transparent;
          border-right: 5px solid transparent;
          position: absolute;
          bottom: 0px;
          left: 37%;
        }
      }
    }
    .tp-chart {
      margin-top: 20px;
      width: 100%;
      height: 16vh;
    }
  }
</style>
